import { FormSubmitResult, ConnectionResultData } from "../common/types";
import { FormComponent } from "@genexus/gemini/dist/types/common/interfaces";

// formSubmitValidation will be deprecated. use "validateControls" instead.
export const formSubmitValidation = (
  result: FormSubmitResult | ConnectionResultData,
  ref: any
) => {
  result.fieldErrors?.forEach(element => {
    const key = element.key;
    const message = element.message;
    const hasError = element.hasError;

    const reference: FormComponent = ref[`${key}El`];
    if (reference && hasError && message.trim()) {
      reference.validationStatus = "error";
      reference.validationMessage = message;
    } else if (reference && !hasError) {
      reference.validationStatus = "indeterminate";
      reference.validationMessage = null;
    }
  });
};

// TODO: Improve the way we mark components with error. We must not use error classes.
const formElementsErrorClassesDictionary = {
  "ch-checkbox": "checkbox-error",
  "ch-combo-box-render": "combo-box-error",
  "ch-edit": "input-error"
} as const;

const toggleErrorClass = (hasError: boolean, element: HTMLElement) => {
  const elementTagName = element.tagName.toLowerCase();
  const errorClass =
    formElementsErrorClassesDictionary[
      elementTagName as keyof typeof formElementsErrorClassesDictionary
    ];
  if (hasError) {
    element.classList.add(errorClass);
  } else {
    element.classList.remove(errorClass);
  }
};

export const validateControls = (
  formSubmitResult: FormSubmitResult,
  validatableControls: Map<string, ControlValidation>
): Map<string, ControlValidation> => {
  const validatableControlsUpdated = new Map(validatableControls);
  formSubmitResult.fieldErrors.forEach(fieldResult => {
    const fieldKey = fieldResult.key;
    const fieldHasError = fieldResult.hasError;
    const controlMapRecord = validatableControlsUpdated.get(fieldKey);
    if (controlMapRecord?.reference) {
      // toggle class to add or remove error style
      toggleErrorClass(fieldHasError, controlMapRecord.reference);
      validatableControlsUpdated.set(fieldKey, {
        ...controlMapRecord,
        hasError: fieldHasError,
        message: fieldResult.message
      });
    }
  });
  // return validatableControls updated.
  return validatableControlsUpdated;
};

export const clearControlError = (
  validatableControls: Map<string, ControlValidation>,
  controlId: string
) => {
  const control = validatableControls.get(controlId);
  if (control?.reference) {
    toggleErrorClass(false, control.reference);
    control.hasError = false;
    control.message = "";
    validatableControls.set(controlId, control);
  }
};

export type ControlValidation = {
  reference: HTMLElement;
  hasError: boolean;
  message: string;
};
